import * as React from 'react'
import * as PropTypes from 'prop-types'

interface IVisibilityProvider {
  children: (state: { visible: boolean }) => React.ReactNode
}

export class VisibilityProvider extends React.Component<IVisibilityProvider> {
  static propTypes = {
    children: PropTypes.func,
  }

  state = {
    visible: false,
  }

  componentDidMount() {
    this.setState({ visible: true }) // eslint-disable-line react/no-did-mount-set-state
  }

  render() {
    return this.props.children(this.state)
  }
}
